import PropTypes from 'prop-types'

export default PropTypes.shape({
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
})
